export const validateForPrice = ($event, value) => {
    if(value) {
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        let newValue = value.toString()

        // only allow number and one dot or comma
        if ((keyCode < 48 || keyCode > 57) &&
            (keyCode !== 46 || (keyCode === 46 && newValue == '')) &&
            (keyCode !== 44 || (keyCode === 44 && newValue == ''))) {
            $event.preventDefault();
        }

        if ((keyCode < 48 || keyCode > 57) && (newValue.indexOf('.') != -1 || newValue.indexOf(',') != -1)) {
            $event.preventDefault();
        }

        // restrict to 2 decimal places
        if (newValue != null && newValue.toString().indexOf(".") > -1 && (newValue.toString().split('.')[1].length > 1)) {
            $event.preventDefault();
        }

        if (newValue != null && newValue.toString().indexOf(",") > -1 && (newValue.toString().split(',')[1].length > 1)) {
            $event.preventDefault();
        }
    }
};
